<div [ngClass]="size" *ngIf="showPlusButton()">
  <!-- Has items in cart -->
  <div class="offer-actions" *ngIf="cartItems?.length == 1 && getQuantity() > 0">
    <div class="icon-button container-theme-light-icons" (click)="onDecreaseItemQty($event)"
      title="click to decrease quantity">
      <i class="fa fa-minus m-auto"></i>
    </div>
    <div class="offer-quantity" title="total quantity">
      {{ getQuantity() }}
    </div>
    <div class="icon-button container-theme-light-icons"
      (click)="currentCartStatus === 'LOADED' && onOneClickAddToCart($event)" title="click to add more">
      <i class="fa fa-plus m-auto"></i>
    </div>
  </div>

  <!-- No items in cart -->
  <div class="icon-clickable-area" (click)="currentCartStatus === 'LOADED' && onOneClickAddToCart($event)"
    *ngIf="!cartItems?.length || getQuantity() == 0" 
    [ngClass]="{'offer-image-action': offer.standardImage, 'offer-no-image-action':!offer.standardImage}">
    <div class="icon-button container-theme-light-icons add-button">
      <i class="fa fa-plus m-auto plus-icon-catalog"></i>
    </div>
  </div>

  <!-- Different cart items -->
  <div class="total-offer-quantity theme-light" *ngIf="cartItems?.length > 1" title="total quantity">
    <div class="offer-quantity">
      {{ getQuantity() }}
    </div>
  </div>
</div>